import { GROUP_ID } from "@erp/shared/types/user.types";
/**
 * 그룹별 업무 권한 매핑 (프론트엔드)
 *
 * 페이지 접근 권한은 DB(group_page_permission 테이블)에서 관리합니다.
 * 이 파일은 페이지 접근 외의 "업무 권한"을 정의합니다.
 *
 * ── 사용법 ──
 * 새로운 업무 권한이 필요하면:
 *   1. 이 파일에 상수를 추가하고
 *   2. 코드에서 import하여 사용합니다.
 *
 * ── 주의 ──
 * 백엔드에도 동일한 매핑 파일이 있습니다:
 *   nest-server/src/common/const/group-capability.const.ts
 * 양쪽을 함께 관리해야 합니다.
 */
/** 자재 단가를 볼 수 있는 그룹 (나머지 그룹은 price 필드가 마스킹됨) */
export const PRICE_VISIBLE_GROUP_IDS = [
    Number(GROUP_ID.관리자),
    Number(GROUP_ID.자재금액노출),
];
/** 구매 담당자로 할당될 수 있는 그룹 */
export const PURCHASE_MANAGER_GROUP_IDS = [
    Number(GROUP_ID.구매관리),
];
/** 제품 데이터 등록/수정 가능 그룹 (백엔드 PermissionGuard로 보호) */
export const PRODUCT_UPSERT_GROUP_IDS = [
    Number(GROUP_ID.관리자),
];
/**
 * 그룹별 업무 권한 설명 (권한 설정 페이지 UI 표시용)
 *
 * 페이지 접근 외에 코드에서 제어되는 업무 권한을 설명합니다.
 * 새로운 업무 권한을 추가할 때 이 매핑도 함께 업데이트해주세요.
 */
export const GROUP_CAPABILITY_DESCRIPTIONS = {
    [GROUP_ID.관리자]: [
        "자재 단가 열람 가능",
        "제품 데이터 일괄 등록/수정 가능",
    ],
    [GROUP_ID.자재금액노출]: [
        "자재 단가 열람 가능",
    ],
    [GROUP_ID.구매관리]: [
        "구매 담당자로 할당 가능",
    ],
};
